import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { CurrencyLabel } from '.'

const CatalogCurrencyLabel = props => {
  if (props.checkCashOnly && props.onlyCash) {
    return (
      <CurrencyLabel
        id={props.id}
        value={props.price.cash}
        prefixLabel={`${props.prefix || ''} R$ `}
        decimalPlaces={2}
        className={`txt-initial ${props.className}`}
        showpointsName={false}
      />
    )
  }

  return (
    <CurrencyLabel
      id={props.id}
      label={props.label}
      prefixLabel={props.prefix || ''}
      value={props.value || (props.price && props.price.points) || 0}
      decimalPlaces={props.decimalPlaces}
      className={props.className}
      showpointsName={props.showpointsName}
    />
  )
}

CatalogCurrencyLabel.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  price: PropTypes.object,
  decimalPlaces: PropTypes.number,
  className: PropTypes.string,
  showpointsName: PropTypes.bool,
  onlyCash: PropTypes.bool,
  checkCashOnly: PropTypes.bool,
  prefix: PropTypes.string
}

const mapStateToProps = ({ catalog: { currencyConfiguration }, onlyCash }) => ({
  label: currencyConfiguration.pointsName,
  decimalPlaces: currencyConfiguration.decimalPlaces,
  onlyCash
})

export default connect(
  mapStateToProps,
  null
)(CatalogCurrencyLabel)



// WEBPACK FOOTER //
// ./src/Shared/CurrencyLabel/CatalogCurrencyLabel.js